import {Show, Text, VStack} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface PriceNotAvailableProps extends TestIdProps {
  title?: string;
  align?: 'left' | 'right';
}

/**
 * A price the server returned as `null`. The server nulls a price the user may not see, so it
 * reads as not available, never as zero or as an empty price.
 */
export function PriceNotAvailable(props: PriceNotAvailableProps) {
  return (
    <VStack
      spacing={2}
      align={props.align === 'right' ? 'flex-end' : undefined}
      data-testid={props['data-testid']}
    >
      <Show when={isNotNilOrEmpty(props.title)}>
        <Text size="xSmall" color="secondary">
          {props.title}
        </Text>
      </Show>
      <Text size="small" color="secondary" data-testid={suffixTestId('notAvailable', props)}>
        {i18n.t('entity.workshop.labels.notAvailable')}
      </Text>
    </VStack>
  );
}
